import { render } from "./IndexInventaire.vue?vue&type=template&id=5d733394"
import script from "./IndexInventaire.vue?vue&type=script&lang=js"
export * from "./IndexInventaire.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__